import { Typography } from "@mui/material"
import { ICampaign } from "campaign/model"
import { getDeliveryIndex } from "campaign/tools/delivery-index"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IDeliveryIndexProps {
  campaign: ICampaign
}

export const DeliveryIndex = React.memo(({ campaign }: IDeliveryIndexProps) => {
  const deliveryIndex = getDeliveryIndex(campaign)
  if (deliveryIndex === undefined) {
    return null
  }
  return (
    <FlexBox
      sx={{
        backgroundColor: theme => (deliveryIndex < 0 ? theme.palette.error.light : theme.palette.success.light),
        p: ".5rem",
        pl: "1rem",
        pr: "1rem",
        borderRadius: ".25rem"
      }}>
      <Typography
        fontSize=".8rem"
        fontWeight="300"
        sx={{
          color: theme => (deliveryIndex < 0 ? theme.palette.error.contrastText : theme.palette.success.contrastText),
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}>
        {deliveryIndex.toFixed(2)}%
      </Typography>
    </FlexBox>
  )
})
